import { useQuery } from "@tanstack/react-query"
import { useGetImdf } from "../useGetImdf"
import { Post, PostData } from "../../../types"
import { fetchGeojson } from "../../../utils/fetchUtils"
import { preparePostData } from "./utils/preparePostData"
import { useCallback } from "react"

export const useGetPosts = () => {
  const { data: imdfData } = useGetImdf()
  const findOne = useCallback(
    (id) => imdfData.features.find((f) => f.id === id),
    [imdfData]
  )

  const query = useQuery<Post[], unknown, PostData[]>({
    queryKey: ["posts"],
    queryFn: async () => {
      const response = await fetchGeojson<Post>("post", "/")
      return response.data
    },
    select: (posts: Post[]): PostData[] =>
      posts.map((post) => preparePostData(post, findOne)),
    placeholderData: [],
    refetchOnWindowFocus: false,
    enabled: !!imdfData,
  })

  return query
}
